module.exports = __webpack_public_path__ + "static/media/da-DK.c8f74773.md";